import { PageHeader } from "../components/nk/PageHeader";
import { Collections } from "../components/nk/Collections";
import { CollectionEditorial } from "../components/nk/CollectionEditorial";
import { EditorialMarquee } from "../components/nk/EditorialMarquee";
import { CtaBand } from "../components/nk/CtaBand";
import { Seo } from "../components/nk/Seo";

export default function CollectionsPage() {
  return (
    <>
      <Seo
        title="Wedding Gown Collection — Made by Hand in Perth | NK Bridal"
        description="Explore NK Bridal's couture wedding gown collection — beaded columns, cathedral ballgowns, cowl-back satin and florals, designed and hand-sewn in Perth by a Brisbane seamstress."
        path="/collections"
      />
      <PageHeader
        eyebrow="The Collection"
        title={["Gowns made", "by hand"]}
        intro="A selection of NK Bridal pieces — each designed, cut and sewn by Nancy, and made to order entirely to you. Silhouettes range from beaded columns and cathedral ballgowns to floral minis and cowl-back satin."
      />
      <Collections hideHeading />
      <CollectionEditorial />
      <EditorialMarquee />
      <CtaBand />
    </>
  );
}
